<template>
  <div class="adp-catalog-wrapper">
    <div class="d-flex justify-content-between hide-mobile" v-if="role === 'employee'">
      <div class="d-flex justify-content-between">
        <button class="btn adp-btn" @click="chooseActivity()">
          {{ $t('catalog.add_to_idp') }}
        </button>
      </div>
      <div style="margin-bottom: -12px;">
        <span class="adp-p adp-p__small">{{ $t('catalog.dont_you_found') }}</span> <br>
        <span class="adp-p adp-p__small adp-p__grey">{{ $t('catalog.you_can_create_new') }}</span>
      </div>
    </div>
    <div class="d-flex justify-content-between hide-mobile" v-if="role === 'hr'">
      <div class="d-flex justify-content-between">
        <button class="btn adp-btn mr-3" @click="createEvent" :disabled="loading">
          {{ $t('catalog.create_event') }}
        </button>
        <button class="btn adp-btn mr-3" @click="importFromExcel()" :disabled="loading">
          {{ $t('catalog.import_from_excel') }}
        </button>

        <!-- for "add from catalog" from IDP -->
        <button v-if="pernumber && !pernumbersFromEmployeeList.length"
                class="btn adp-btn mr-3" @click="chooseActivity()"
                :disabled="!Object.keys(assignItems).length && loading">
          {{ $t('catalog.add_to_idp') }}
        </button>

        <!-- for "add from catalog" from Employee List -->
        <button v-if="pernumbersFromEmployeeList.length"
                class="btn adp-btn mr-3" @click="chooseActivity()"
                :disabled="!Object.keys(assignItems).length && loading">
          {{ $t('catalog.assign_to_employees') }}
        </button>

        <!-- from Catalog menu -->
        <button class="btn adp-btn mr-3" @click="showActionsMenu" :disabled="loading">
          {{ $t('voc.actions') }} <img src="/images/arrow.svg" style="padding-left: 10px">
        </button>
        <div class="adp-task--crud-actions" v-click-outside="() => hideActionsMenu()" :style="actionsMenuStyles"
             v-if="actionsMenu.isVisible">
          <button v-if="!pernumber && !pernumbersFromEmployeeList.length && doAssignItemsHaveExpiredActivity() === false"
                  class="btn adp-btn adp-btn__t-left adp-btn__light adp-p__margin" @click="openMassAssignments(true)"
                  :disabled="!Object.keys(assignItems).length && loading">
            {{ $t('catalog.assign_to_employees') }}
          </button>
          <button
                  class="btn adp-btn adp-btn__t-left adp-btn__light adp-p__margin" @click="openMassPeriod"
                  :disabled="!Object.keys(assignItems).length && loading">
            {{ $t('catalog.mass_period') }}
          </button>
        </div>

        <div class="d-flex align-items-center mr-4 ml-4" :class="{'catalog-switched': expiredChange}">
          <p class="mb-0 mr-2 catalog-switch-text">{{ $t('catalog.hide_expired') }}</p>
          <b-form-checkbox style="margin-bottom: 7px" switch size="lg" @change="expiredChangeToggle($event)" checked="true" />
        </div>

        <div class="d-flex align-items-center" :class="{'catalog-switched': inactiveChange}">
          <p class="mb-0 mr-2 catalog-switch-text">{{ $t('catalog.hide_inactive') }}</p>
          <b-form-checkbox style="margin-bottom: 7px" switch size="lg" @change="inactiveChangeToggle($event)" checked="true" />
        </div>
      </div>
    </div>
    <div class="d-flex hide-mobile" v-if="role === 'manager' || role === 'fmanager'">
      <!-- for "add from catalog" from IDP -->
      <button v-if="pernumber && !pernumbersFromEmployeeList.length"
              class="btn adp-btn mr-1" @click="chooseActivity()"
              :disabled="!Object.keys(assignItems).length && loading">
        {{ $t('catalog.add_to_idp') }}
      </button>

      <!-- for "add from catalog" from Employee List -->
      <button v-if="pernumbersFromEmployeeList.length"
              class="btn adp-btn mr-1" @click="chooseActivity()"
              :disabled="!Object.keys(assignItems).length && loading">
        {{ $t('catalog.assign_to_employees') }}
      </button>

      <!-- from Catalog menu -->
      <button v-if="!pernumber && !pernumbersFromEmployeeList.length"
              class="btn adp-btn mr-3" @click="openMassAssignments(true)"
              :disabled="!Object.keys(assignItems).length && loading">
        {{ $t('catalog.assign_to_employees') }}
      </button>
    </div>
    <div class="hide-pc adp-fulltext">
      <span class="adp-p adp-p__small adp-p__grey">{{ $t('catalog.search_any_way') }}</span>
      <input type="text" class="adp-input adp-input__catalog adp-input-search" style="margin-top: 6px;">
    </div>

    <div v-if="loading">{{ $t('voc.loading') }}</div>
    <div class="adp-grid-table" v-if="!loading">
      <div class="adp-grid-row hide-mobile adp-grid-row__hr">
        <div class="adp-grid-cell adp-grid-cell__chbox">
          <b-form-checkbox v-model="selectAllAll" :indeterminate="selectAllIndeterminate" @change="selectAll($event)">&nbsp;</b-form-checkbox>
        </div>
        <div class="d-flex flex-column adp-grid-cell__head">
          <div @click="sortChange('group')">
            <span class="adp-th adp-th__sort" :class="{'adp-th__active': sortColumn === 'group'}">
              {{ $t('catalog.group') }}
            </span>
            <span class="adp-th adp-th__sort__icon">
              <img :src="getSortingIcon('group')" alt="sort">
            </span>
          </div>
          <my-dropdown :options="activityGroups" :init-selected="filterGroups" :has-select-all="true"
                       v-on:my-change="onDropdownUpdate($event, 'filterGroups', 'activityGroups')" :localize="false" :readonly="false" ref="dropdownGroups">
          </my-dropdown>
        </div>
        <div class="d-flex flex-column adp-grid-cell__head">
          <div @click="sortChange('competence')">
            <span class="adp-th adp-th__sort" :class="{'adp-th__active': sortColumn === 'competence'}">
              {{ $t('catalog.competencies') }}
            </span>
            <span class="adp-th adp-th__sort__icon">
              <img :src="getSortingIcon('competence')" alt="sort">
            </span>
          </div>
          <my-dropdown :options="competencies" :init-selected="filterCompetencies" :has-select-all="true"
                       v-on:my-change="onDropdownUpdate($event, 'filterCompetencies', 'competencies')" :localize="false" :readonly="false" ref="dropdownCompetencies">
          </my-dropdown>
        </div>
        <div class="d-flex flex-column adp-grid-cell__head">
          <div @click="sortChange('source')">
            <span class="adp-th adp-th__sort" :class="{'adp-th__active': sortColumn === 'source'}">
              {{ $t('catalog.source') }}
            </span>
            <span class="adp-th adp-th__sort__icon">
              <img :src="getSortingIcon('source')" alt="sort">
            </span>
          </div>
          <my-dropdown :options="sources" :init-selected="filterSources" :has-select-all="true"
                       v-on:my-change="onDropdownUpdate($event, 'filterSources', 'sources')" :localize="true" :readonly="false" ref="dropdownSources">
          </my-dropdown>
        </div>
        <div class="d-flex flex-column adp-grid-cell__head">
          <div @click="sortChange('name')">
            <span class="adp-th adp-th__sort" :class="{'adp-th__active': sortColumn === 'name'}">
              {{ $t('voc.table_name') }}
            </span>
            <span class="adp-th adp-th__sort__icon">
              <img :src="getSortingIcon('name')" alt="sort">
            </span>
          </div>
          <input @input="debounceFilterName" type="text" class="adp-input adp-input__catalog adp-input-search" v-model="filterName">
        </div>
      </div>

      <div class="adp-grid-row adp-grid-row__hr"
           :class="{'adp-grid-row__warning': !item.is_valid, 'adp-grid-row__disabled': new Date(item.end_at) < new Date() }"
           v-for="(item, i) in items"
           style="cursor: pointer" @click="showViewModalByClick(item)">
        <div class="adp-grid-cell adp-grid-cell__chbox" @click.stop>
          <b-form-checkbox :disabled="disabled(item)" v-model="item.is_checked" @change="selectEvent($event, item)">&nbsp;</b-form-checkbox>
        </div>
        <div class="adp-grid-cell adp-grid-cell__type position-relative">
          <span class="adp-p">{{ item.competence_group ? item.competence_group.name : '' }}</span>
        </div>
        <div class="adp-grid-cell">
          <span class="adp-p">
            <template v-if="item.competencies.length && !loading">
              {{
                item.competencies.map(id => {
                  if (competencies.find(c => c.id === id)) {
                    return competencies.find(c => c.id === id).code;
                  } else {
                    return '';
                  }
                }).join(', ')
              }}
            </template>
          </span>
        </div>
        <div class="adp-grid-cell">
          <span class="adp-p">{{ getSourceName(item.type) }}</span>
        </div>
        <div class="adp-grid-cell adp-grid-cell__title">
          <span class="adp-p" style="max-width: 85%">{{ item.name }}</span>
          <div class="adp-kebab">
            <img src="/images/red_warning.svg" alt="" v-tooltip.top-end="{ content: $t('catalog.not_fully_valid') }" style="cursor: pointer;" v-if="!item.is_valid">
            <img src="/images/vertical_dots.svg" alt="" style="padding: 2px 6px; cursor: pointer;" @click.stop="openCM($event, item.id, item.type)">
          </div>
        </div>
      </div>
    </div>
    <div class="adp-pagination" v-if="!loading">
      <div class="adp-pagination-bnt" v-for="(page, index) in pages" v-if="page.url || page.label === '...'" @click="changePage(page.label)"
           :class="{'adp-pagination-bnt__active': page.active}">
        <span v-if="page.label === 'pagination.previous' && page.url"><</span>
        <span v-else-if="page.label === 'pagination.next' && page.url">></span>
        <span v-else>{{ page.label }}</span>
      </div>
      <div style="width: 190px; margin-left: 30px">
        <v-select style="background-color: white" label="text"
          :options="itemsPerPage"
          :clearable="false"
          v-model="itemsPerPageSelected"
          @option:selecting="selectItemsPerPage($event)"
        >
        </v-select>
      </div>
    </div>

    <!-- Context Menu -->
    <div class="adp-task--crud-actions" :style="cmStyles" v-if="contextMenu.isVisible" v-click-outside="() => hideCM()" ref="contextMenu">
      <div class="btn adp-btn adp-btn__t-left adp-btn__light" v-if="role === 'hr'" @click="showViewModal();">
        {{ $t('catalog.view_edit') }}
      </div>
      <div class="btn adp-btn adp-btn__t-left adp-btn__light" v-if="role === 'manager' || role === 'employee' || role === 'fmanager'"
           @click="showViewModal();">
        {{ $t('catalog.cm_view') }}
      </div>
      <template v-if="contextMenuActivity.isValid && contextMenuActivity.isExpired === false">
        <div class="btn adp-btn adp-btn__t-left adp-btn__light" @click="openMassAssignments(false)"
             v-if="(role === 'hr' || role === 'manager' || role === 'fmanager') && !pernumber && !pernumbersFromEmployeeList.length">
          {{ $t('catalog.assign_to_employees') }}
        </div>
        <div class="btn adp-btn adp-btn__t-left adp-btn__light" @click="chooseActivity(true)"
             v-if="(role === 'hr' || role === 'manager' || role === 'fmanager') && !pernumber && pernumbersFromEmployeeList.length">
          {{ $t('catalog.assign_to_employees') }}
        </div>
        <div class="btn adp-btn adp-btn__t-left adp-btn__light" @click="chooseActivity(true)"
             v-if="role === 'employee' || !!pernumber">
          {{ $t('catalog.add_to_idp') }}
        </div>
      </template>
      <div class="btn adp-btn adp-btn__t-left adp-btn__light" v-if="role === 'hr'" @click="$bvModal.show('assignment-view-modal')">
        {{ $t('catalog.view_assignment') }}
      </div>
      <div class="btn adp-btn adp-btn__t-left adp-btn__light"
           v-if="role === 'hr' && contextMenu.activityType === 'external'"
           @click="deleteActivityFromCatalog">
        {{ $t('idp.cm_delete') }}
      </div>
      <div class="btn adp-btn adp-btn__t-left adp-btn__light"
           v-if="role === 'hr' && contextMenu.activityType === 'external'"
           @click="copyEvent">
        {{ $t('idp.cm_duplicate') }}
      </div>
      <div class="btn adp-btn adp-btn__t-left adp-btn__light"
           v-if="role === 'hr' && !pernumber && !pernumbersFromEmployeeList.length"
           @click="openMassPeriod"
      >
        {{ $t('catalog.mass_period') }}
      </div>
    </div>

    <!-- Modal -->
    <b-modal id="catalog-alert-assignments-modal" hide-footer
             :modal-class="`adp-modal adp-modal__no_footer catalog-mass-assignments-alert-modal mass-assignments-alert-modal`"
             :body-class="`adp-modal-body`">
      <template #modal-header-close>
        <button type="button" class="close adp-close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true"><img src="/images/cross.svg" alt=""></span>
        </button>
      </template>
      <template>
        <div class="mass-assignments-alert">
          {{ $t('catalog.assign_need_activity') }}
        </div>
      </template>
    </b-modal>

    <b-modal id="alert-assign-modal-list"
             :modal-class="`adp-modal`"
             :body-class="`adp-modal-body no-empty-space-mass-assignments`"
             :footer-class="`adp-modal-footer d-flex justify-content-center align-self-end p-2 m-2`">
      <template #modal-header-close>
        <button type="button" class="close adp-close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true"><img src="/images/cross.svg" alt=""></span>
        </button>
      </template>
      <template v-if="role === 'employee'">
        <div class="mass-assignments-alert pb-0" v-for="assignedActivity in assignedActivities">
          {{ $t('catalog.learning') }}
          {{ assignedActivity }}
          {{ $t('catalog.learning_already_exists') }}
          <br>
        </div>
      </template>
      <template v-else>
        <div class="mass-assignments-alert pb-0" v-for="assignedActivity in assignedActivities">
          {{ $t('catalog.learning') }}
          {{ assignedActivity }}
          {{ $t('catalog.learning_already_exists_in_employee') }}
          <br>
        </div>
      </template>
      <template #modal-footer>
          <button v-if="role === 'employee'" class="btn adp-btn adp-btn__large" style="z-index: 1;" @click="goToMyIDP">
              {{ $t('catalog.go_to_my_idp') }}
          </button>
          <button v-else class="btn adp-btn adp-btn__large " style="z-index: 1;" @click="goToEmployeeIDP">
            {{ $t('catalog.go_to_employee_idp') }}
          </button>
      </template>
    </b-modal>

    <common-event-view-modal :activity-id="Number(contextMenuActivity.activityId)"
                             :activity-type="String(contextMenuActivity.activityType)"
                             :is-editable="false"
                             :is-edit="Boolean(contextMenu.isEdit)"
                             :searched-employees="searchedEmployees"
                             :group-options="groupOptions"
                             :groups-tree="rawCompetencies"
                             :provider-options="providerOptions"
                             @updateActivities="getActivities"
                             @coachFioInput="debounceSearchCoach"
                             @closeCoachMenu="closeEventModal"
    />

    <common-event-create-modal :searched-employees="searchedEmployees"
                               :group-options="groupOptions"
                               :groups-tree="rawCompetencies"
                               :provider-options="providerOptions"
                               @updateActivities="getActivities"
                               :copy-data="copyData"
                               @coachFioInput="debounceSearchCoach"
                               @closeCoachMenu="closeEventModal"
    />

    <deadline-modal v-if="activities.length && !pernumbersFromEmployeeList.length"
                    :activity="activities[0]"
                    :idp-status="String(IDP.status)"
                    @setDeadline="assignActivity"
                    @closeDeadlineModal="deleteActivity"
    />


    <mass-assignment-modal v-if="showMassAssignments"
                           :learning-activity-ids="assignItems"
                           :learning-activity="contextMenuActivity"
    />

    <div v-for="(activity, i) in activities" :key="i" v-if="pernumbersFromEmployeeList.length">
      <mass-deadlines-modal :activity="activity" :activity-index="i" />
    </div>

    <assignments-view-modal :activity-id="Number(contextMenuActivity.activityId)"
                            :activity-name="String(contextMenuActivity.name)" />

    <add-training-modal :learning-activity-name="String(contextMenuActivity.name)" @choose-training="chooseTraining"/>

    <mass-period-modal :activities="Object.values(contextMenuActivity).length ? [contextMenuActivity] : selectedActivities" @period-updated="periodsUpdated"/>

    <reports-modal v-show="isReportsOpened" :is-reports-opened="isReportsOpened" @close-reports-modal="isReportsOpened = false"/>
  </div>
</template>

<script>
import {find, findIndex, debounce} from 'lodash';
import MyDropdown from './MyDropdown';
import MyTreeFilter from './MyTreeFilter';
import {updateUrl} from "../updateUrl";
import api from "../api";
import CommonEventViewModal from "./modals/CommonEventViewModal";
import CommonEventCreateModal from "./modals/CommonEventCreateModal";
import DeadlineModal from "./modals/DeadlineModal";
import MassAssignmentModal from "./modals/MassAssignmentsModal";
import ActivityTypeSelect from "./ActivityTypeSelect";
import MassDeadlineModal from "./modals/MassDeadlineModal";
import AssignmentsViewModal from "./modals/AssignmentsViewModal";
import AddTrainingModal from "./modals/AddTrainingModal";
import MassPeriodModal from "./modals/MassPeriodModal.vue";
import ReportsModal from "./modals/ReportsModal";

export default {
  name: "Catalog",
  components: {
    'add-training-modal': AddTrainingModal,
    'activity-type-select': ActivityTypeSelect,
    'my-dropdown': MyDropdown,
    'my-tree-filter': MyTreeFilter,
    'common-event-view-modal': CommonEventViewModal,
    'common-event-create-modal': CommonEventCreateModal,
    'mass-assignment-modal': MassAssignmentModal,
    'deadline-modal': DeadlineModal,
    'mass-deadlines-modal': MassDeadlineModal,
    'assignments-view-modal': AssignmentsViewModal,
    'mass-period-modal': MassPeriodModal,
    'reports-modal': ReportsModal,
  },
  data: function () {
    return {
      reportsButton: document.getElementById('reports-download'),
      reportsLoadingButton: document.getElementById('reports-download-circle'),
      isReportsOpened: false,

      loading: false,
      locale: 'RU',
      expiredChange: true,
      inactiveChange: true,

      itemsPerPage: [
        {number: 20, text: `20 ${this.$t('idp.per_page')}`},
        {number: 50, text: `50 ${this.$t('idp.per_page')}`},
        {number: 100, text:`100 ${this.$t('idp.per_page')}`},
      ],
      itemsPerPageCount: 20,
      role: 'employee',

      selectAllAll: false,
      selectAllIndeterminate: false,

      allItems: [],
      items: [],


      filterName: '',
      names: [],

      filterSources: [],
      sources: [],

      filterCompetencies: [],
      competencies: [],

      filterGroups: [],
      activityGroups: [],

      pages: [],
      activePage: 1,

      actionsMenu: {
        isVisible: false,

        top: 0,
        left: 0,
        right: 0,
      },

      contextMenu: {
        isVisible: false,

        activityId: null,
        activityType: null,
        activity: {},

        isEdit: true,
        top: 0,
        left: 0,
      },

      contextMenuActivity: {},

      assignItems: {},
      showMassAssignments: false,

      pernumber: '',
      assignedActivities: [],
      activities: [],
      activityGroup: null,
      IDP: null,

      pernumbersFromEmployeeList: [],
      currentYear: new Date().getFullYear(),
      sortColumn: '',
      sortDirection: '',
      lastUsedFilterOptions: '',

      rawCompetencies: [],
      checkedItems: [],
      checkedIds: [],
      searchedEmployees: [],
      groupOptions: [],
      providerOptions: [],

      copyData: null,

      selectedActivities: [],

      filters: {},
    }
  },
  watch: {
    sortColumn(newVal) {
      this.updateUrl({sortColumn: newVal && newVal.length ? String(newVal) : null});
    },
    sortDirection(newVal) {
      this.updateUrl({sortDirection: newVal && newVal.length ? String(newVal) : null});
    },
    filterName(newVal) {
      this.updateUrl({filterName: newVal && newVal.length ? String(newVal) : null});
    },
    filterCompetencies(newVal) {
      this.updateUrl({filterCompetencies: newVal && newVal.length ? newVal.join('_') : null});
    },
    filterSources(newVal) {
      this.updateUrl({filterSources: newVal && newVal.length ? newVal.join('0') : null});
    },
    filterGroups(newVal) {
      this.updateUrl({filterGroups: newVal && newVal.length ? newVal.join('0') : null});
    },
    filters(newVal) {
      this.updateFilterOptions();
    },
    assignItems(newVal) {
      const checkedIds = Object.keys(newVal);
      let activities = [];
      activities.push(...this.allItems.filter(x => checkedIds.includes(String(x.id))));

      activities.forEach(a => {
        if (!this.selectedActivities.find(s => s.id === a.id)) {
          this.selectedActivities.push(a);
        }
      });
    }
  },
  computed: {
    cmStyles() {
      return {
        top: `${this.contextMenu.top}px`,
        left: `${this.contextMenu.left}px`,
        right: 'unset',
      };
    },
    itemsPerPageSelected: {
      get() {
        return this.itemsPerPage.find(item => item.number === this.itemsPerPageCount).text
      },
      set({number}) {
        this.itemsPerPageCount = number;
      }
    },
    actionsMenuStyles() {
      return {
        // top: '540px',
        top: `${this.actionsMenu.top}px`,
        left: `${this.actionsMenu.left}px`,
        right: 'unset',
      };
    },
  },
  methods: {
    doAssignItemsHaveExpiredActivity() {
      let expiredActivity = Object.values(this.assignItems).find((e) => e.isExpired);
      return typeof expiredActivity !== 'undefined';
    },
    debounceFilterName: debounce(function () {
      this.resetSelectedItems();
      if (this.activePage > 1) this.changePage(1);
      this.searchItems();
    }, 700),
    getSourceName(type) {
      if (type === 'external') return this.$t('catalog.external');
      if (type === 'course') return this.$t('catalog.course');
      if (type === 'event') return this.$t('catalog.event');
    },
    updateFilterOptions() {
      if (this.lastUsedFilterOptions !== 'competencies' || this.filterCompetencies.length === 0) {
        let data = this.rawCompetencies;

        if (this.role !== 'hr') {
          data = data.filter(x => x.group_name !== 'Обязательное обучение');
        }

        this.competencies = [...new Set(data.map(x => x.comp_id))]
          .filter(x => this.filters.competencies.includes(x))
          .map(x => {
            return { id: x, code: data.find(y => y.comp_id === x).comp_name };
          });
      }

      if (this.lastUsedFilterOptions !== 'activityGroups' || this.filterGroups.length === 0) {
        this.activityGroups = this.filters.groups.map(x => ({id: x.id, code: x.name}));
      }

      if (this.lastUsedFilterOptions !== 'sources' || this.filterSources.length === 0) {
        this.sources = this.filters.sources.map(x => ({id: x, code: x}));
      }
    },
    updateItemsChecked() {
      let items = {};

      let assignedItems = this.items.filter(el => el.is_checked).map(el => {
        return {
          activityId: el.id,
          activityType: el.type,
          personalType: el.personal_type,
          name: el.name,
          isExpired: new Date(el.end_at) < new Date(),
        }
      });

      assignedItems.forEach(item => {
        items[item.activityId] = item;
      })

      this.assignItems = {...this.assignItems, ...items};
    },
    async searchItems() {
      let items = this.allItems;
      let data = {
        role: this.role,
        page: this.activePage,
        count: this.itemsPerPageCount,
        hide_expired: this.expiredChange,
        hide_inactive: this.inactiveChange,
        search_competence_groups: this.filterGroups,
        search_competence: this.filterCompetencies,
        search_source: this.filterSources,
        search_name: this.filterName,
        sort_column: this.sortColumn,
        sort_direction: this.sortDirection,
      };

      let resp = await api.getCatalog(data);
      items = resp.data.data;
      this.allItems = resp.data.data;
      this.pages = resp.data.meta.links;
      items.forEach(el => el.is_checked = false);
      this.items = JSON.parse(JSON.stringify(items))
        .map(i => {
          if (this.checkedIds.includes(i.id)) {
            i.is_checked = true;
          }
          return i;
        });

      const filtersResp = await api.getCatalogFilters(data);
      this.filters = filtersResp.data;
    },
    onDropdownUpdate(e, property, filterOptionsName) {
      this.lastUsedFilterOptions = filterOptionsName;
      this.resetSelectedItems();
      this[property] = e;
      if (this.activePage > 1) this.changePage(1);
      this.searchItems();
    },
    openCM(event, activityId, activityType) {
      this.contextMenu.activityId = activityId;
      this.contextMenu.activityType = activityType;

      this.contextMenu.top = event.pageY;
      this.contextMenu.left = event.pageX - 180;

      this.contextMenu.isVisible = true;

      let activeItem = this.items.find(el => el.id === this.contextMenu.activityId);

      this.contextMenuActivity = {
        activityId: activeItem.id,
        activityType: activeItem.type,
        name: activeItem.name,
        isValid: activeItem.is_valid,
        isExpired: new Date(activeItem.end_at) < new Date(),
      };
    },
    hideCM() {
      this.contextMenu.isVisible = false;
      this.contextMenu.activityId = '';
      this.contextMenu.activityType = '';
    },
    showViewModalByClick(item) {
      this.contextMenu.activityId = item.id;
      this.contextMenu.activityType = item.type;

      this.contextMenuActivity = {
        activityId: item.id,
        activityType: item.type,
        name: item.name,
        isValid: item.is_valid,
        isExpired: new Date(item.end_at) < new Date(),
      };

      this.$nextTick(() => this.showViewModal());
    },
    hide(prop) {
      this[prop] = false;
    },
    sortChange(sortingColumn) {
      if (sortingColumn !== this.sortColumn) {
        this.sortColumn = sortingColumn;
        this.sortDirection = '';
      }

      if (this.sortDirection === '') {
        this.sortDirection = 'asc';
      } else if (this.sortDirection === 'asc') {
        this.sortDirection = 'desc';
      } else if (this.sortDirection === 'desc') {
        this.sortDirection = '';
        this.sortColumn = null;
      }

      this.searchItems();
    },
    getSortingIcon(sortingColumn) {
      if (sortingColumn !== this.sortColumn || this.sortDirection === '') {
        return '/images/sort.svg';
      } else if (this.sortDirection === 'asc') {
        return '/images/sort_active_asc.svg';
      } else if (this.sortDirection === 'desc') {
        return '/images/sort_active_desc.svg';
      }
    },
    async changePage(val) {
      if(val === '...') {
        return;
      }

      if(val === 'pagination.previous') {
        val = Number(this.activePage) - 1;
      }

      if(val === 'pagination.next') {
        val = Number(this.activePage) + 1;
      }

      val = Number(val);

      this.activePage = val;
      if (val === 1) {
        val = null;
      }
      this.updateUrl({p: val});
      await this.getActivities();
      await this.getCompetences();
    },
    updateUrl(params) {
      updateUrl(params);
    },
    showViewModal() {
      this.$bvModal.show('common-event-view-modal');
    },
    openMassAssignments(withChecked) {
      if(withChecked) {
        this.contextMenuActivity = {};
      }

      if (Object.keys(this.assignItems).length || this.contextMenu.activityId) {
        this.showMassAssignments = true;
        setTimeout(() => {
          this.$bvModal.show('mass-assignments-modal');
          $('.adp-navbar').addClass('adp-navbar-fixed');
        }, 100);
      } else {
        this.$bvModal.show('catalog-alert-assignments-modal');
      }
    },

    openMassPeriod() {
      if (this.selectedActivities.length || this.contextMenu.activityId) {
        if (this.contextMenu.activityId) {
          this.contextMenuActivity = this.allItems.find(el => el.id === this.contextMenu.activityId);
        }
        this.$nextTick(() => {
          this.$bvModal.show('mass-period-modal');
        })
      } else {
        this.$bvModal.show('catalog-alert-assignments-modal');
      }
    },

    selectAll(e) {
      if (Object.keys(this.assignItems).length) {
        this.resetSelectedItems();
      } else {
        this.items = this.items.map(el => {
          const dateExpired = new Date(el.end_at) < new Date();
          if (!el.is_valid || (dateExpired && this.role !== 'hr')) {
            el.is_checked = false;
          } else {
            el.is_checked = true;
          }
          return el
        });
        this.selectAllAll = true;
      }
      this.selectAllIndeterminate = false;
      this.updateItemsChecked();
      this.saveCheckedIds();
    },

    selectEvent(event, item) {
      let checkedElementsCnt = this.items.filter(el => el.is_checked).length;
      if (this.items.length === checkedElementsCnt) {
        this.selectAllAll = true;
        this.selectAllIndeterminate = false;
      } else if (this.items.length > checkedElementsCnt && checkedElementsCnt > 0) {
        this.selectAllAll = false;
        this.selectAllIndeterminate = true;
      } else {
        this.selectAllAll = false;
        this.selectAllIndeterminate = false;
      }

      this.updateItemsChecked();
      this.saveCheckedIds();
      if (event === false) {
        this.removeUncheckedItems(item.id);
      }
    },

    resetSelectedItems() {
      this.items = this.items.map(el => {el.is_checked = false; return el});
      this.selectAllAll = false;
      this.selectAllIndeterminate = false;
      this.checkedIds = [];
      this.assignItems = {};
      this.selectedActivities = [];
    },

    removeUncheckedItems(removeId) {
      delete this.assignItems[removeId];
      this.selectedActivities = this.selectedActivities.filter(el => el.id !== removeId);
      this.checkedIds = this.checkedIds.filter(el => el !== removeId);
    },

    async periodsUpdated() {
      this.items = this.items.map(x => {
        x.is_checked = false;
        return x;
      })
      this.checkedIds = [];
      this.selectAllAll = false;
      this.selectAllIndeterminate = false;
      this.updateItemsChecked();
      this.saveCheckedIds();

      try {
        await this.getActivities();
      } catch (e) {
        console.error(e);
      }
    },

    saveCheckedIds() {
      this.items.filter(el => el.is_checked).forEach(i => {
        if (!this.checkedIds.includes(i.id)) {
          this.checkedIds.push(i.id)
        }
      });
    },

    chooseActivity(fromContextMenu = false) {
      let elToAssign = this.selectedActivities.map(el => {
        return { activityId: el.id, activityType: el.type, name: el.name, start_at: el.start_at,
          end_at: el.end_at, activityFormat: el.la_format}
      });

      if (!elToAssign.length && !this.contextMenu.activityId) {
        this.$bvModal.show('catalog-alert-assignments-modal');
        return;
      }

      let activities = elToAssign;

      if (activities.length && activities.find(x => x.activityFormat === 'training')
        && activities.find(x => x.activityType === 'external') && this.role !== 'hr') {
        this.contextMenuActivity.activityId = Number(activities[0].activityId);
        this.contextMenuActivity.name = activities[0].name;

        this.$nextTick(() => this.$bvModal.show('add-training-modal'));
        return;
      }

      if (fromContextMenu) {
        let activity = this.allItems.find((el) => {
          return el.id === this.contextMenu.activityId;
        });

        if (activity.la_format === 'training' && activity.type === 'external' && this.role !== 'hr') {
          this.$bvModal.show('add-training-modal');
          return;
        }

        activities = [{
          activityId: this.contextMenu.activityId,
          activityType: activity.type,
          name: activity.name,
          start_at: activity.start_at,
          end_at: activity.end_at,
        }];
      }

      this.activities = activities;
      this.assignedActivities = [];

      if (this.pernumbersFromEmployeeList.length) {
        this.$nextTick(() => {
          this.$bvModal.show('mass-deadlines-modal');
        })
      } else {
        this.$nextTick(() => {
          this.$bvModal.show('deadline-modal');
        })
      }
    },
    chooseTraining() {
      if (this.checkedIds.length > 1) {
        return this.chooseActivitiesIfCheckedTraining();
      }

      let activity = {};
      if (!this.contextMenu.activityId) {
        activity = this.allItems.find(el => el.id === this.contextMenuActivity.activityId);
      } else {
        activity = this.allItems.find(el => el.id === this.contextMenu.activityId);
      }

      this.activities = [{
        activityId: this.contextMenu.activityId || this.contextMenuActivity.activityId,
        activityType: activity.type,
        name: activity.name,
        start_at: activity.start_at,
        end_at: activity.end_at,
      }];
      this.assignedActivities = [];

      this.$nextTick(() => {
        this.$bvModal.show('deadline-modal');
      })
    },
    chooseActivitiesIfCheckedTraining() {
      let elToAssign = this.items.filter(el => el.is_checked).map(el => {
        return { activityId: el.id, activityType: el.type, name: el.name, start_at: el.start_at,
          end_at: el.end_at, activityFormat: el.la_format}
      });

      if (!elToAssign.length && !this.contextMenu.activityId) {
        this.$bvModal.show('catalog-alert-assignments-modal');
        return;
      }

      this.activities = elToAssign;
      this.assignedActivities = [];

      if (this.pernumbersFromEmployeeList.length) {
        this.$nextTick(() => {
          this.$bvModal.show('mass-deadlines-modal');
        })
      } else {
        this.$nextTick(() => {
          this.$bvModal.show('deadline-modal');
        })
      }
    },
    assignActivity(activityId, deadline) {
      const activity = find(this.activities, activityItem => activityItem.activityId === activityId);
      let data = {
        activityId: activityId,
        activityType: activity.activityType,
        role: this.role,
        participant_pernumber: this.pernumber,
        deadline,
      };

      let assignedActivities = [];

      let resp = api.assignCatalogEvent(data);

      resp.then((response) => {
        if (response.data.success && response.status === 200 && this.activities.length === 1 && !this.assignedActivities.length) {
          if (this.role === 'employee') {
            window.location.pathname = "/" + this.role;
          } else {
            window.location.pathname = "/" + this.role + "/employee/" + this.pernumber;
          }
        } else if (response.data.assignedActivities && Object.keys(response.data.assignedActivities).length) {

          for (let item of Object.values(response.data.assignedActivities)) {
            let activity;
            if (item.catalog_id) {
              activity = this.allItems.find(el => el.id === item.catalog_id);
            } else {
              activity = this.allItems.find(el => el.id === item.idps_learning_activity_id);
            }

            assignedActivities.push(activity.name)
          }

          this.assignedActivities.push(...assignedActivities);
        }

        this.deleteActivity(activityId);
      }).catch((e) => {
        console.log(e);
      })
    },

    deleteActivity(activityId) {
      const activityIndex = findIndex(this.activities, activityItem => activityItem.activityId === activityId);
      this.activities.splice(activityIndex, 1);

      if (!this.activities.length && this.assignedActivities.length) {
        setTimeout(() => {
          this.$bvModal.show('alert-assign-modal-list');
        }, 200);
      }
    },

    async search(loading, search, vm) {
      try {
        let res = await api.searchCommonEvents(search);
        this.names = res.data.map(el => el.name);
        this.filterName = search;

        await this.searchItems();
      } catch (e) {
        console.error(e);
      }
      loading(false);
    },

    async getCompetences() {
      try {
        let res = await api.getCompetenciesList(this.role);
        this.rawCompetencies = res.data;

        let resData = res.data;
        if (this.role !== 'hr') {
          resData = res.data.filter(x => x.group_name !== 'Обязательное обучение');
        }


        this.updateFilterOptions();

        this.groupOptions = [...new Set(resData.filter(x => x.group_is_hidden === 0).map(x => x.group_id))].map(x => {
          return { code: x, label: resData.find(y => y.group_id === x).group_name };
        });
      } catch (e) {
        console.error(e);
      }
    },
    async getActivities() {
      this.$bvModal.hide('common-event-view-modal');
      this.$bvModal.hide('common-event-create-modal');
      this.$bvModal.hide('deadline-modal');
      this.$bvModal.hide('assignments-view-modal');

      await this.searchItems();
      await this.getIdp();
      await this.getEmployeesFromEmployeeList();
    },
    async selectItemsPerPage(event) {
      event.number > 20 ? this.activePage = 1 : this.activePage
      this.itemsPerPageCount = event.number;
      await this.searchItems();
    },

    async getIdp() {
      let employeePernumber = '';
      if (this.$route && this.$route.query.pernumber) {
        employeePernumber = this.$route.query.pernumber;
      } else if (window.IDP.pernumber && window.IDP.role === 'admin') {
        employeePernumber = window.IDP.pernumber;
      } else if (window.IDP.pernumber && (window.IDP.role === '' || window.IDP.role === 'employee')) {
        employeePernumber = window.IDP.pernumber;
      }

      if (employeePernumber) {
        try {
          let resp = await api.getIDP(employeePernumber, [this.currentYear]);
          let idp = resp.data;
          this.IDP = {
            id: idp.activeIdp.id,
            status: idp.activeIdp.status,
          };
        } catch (e) {
          console.error(e);
        }
      }
    },
    createEvent() {
      this.copyData = null;
      this.$nextTick(() => this.$bvModal.show('common-event-create-modal'));
    },
    importFromExcel() {
      const input =  document.createElement('input');
      input.type = 'file';
      input.onchange = e => this.getExcelFile(e);
      input.click();
    },
    async getExcelFile(e) {
      const file = e.target.files[0];
      const data = new FormData();
      data.append('file', file)

      await api.importActivityFromExcel(data);
    },
    clearFilters() {
      this.filterGroups = [];
      this.$refs['dropdownGroups'].selected = [];
      this.filterCompetencies = [];
      this.$refs['dropdownCompetencies'].selected = [];
      this.filterSources = [];
      this.$refs['dropdownSources'].selected = [];
      this.filterName = '';
      this.resetSelectedItems();
    },
    async expiredChangeToggle(e) {
      this.expiredChange = e;
      this.clearFilters();
      await this.changePage(1);
    },
    async inactiveChangeToggle(e) {
      this.inactiveChange = e;
      this.clearFilters();
      await this.changePage(1);
    },
    async getEmployeesFromEmployeeList() {
      let employeePernumbers = [];
      if (this.$route && this.$route.query.pernumbers) {
        employeePernumbers = this.$route.query.pernumbers.split(',');
        this.pernumbersFromEmployeeList = employeePernumbers;
      }
    },
    goToMyIDP() {
      this.$bvModal.hide('alert-assign-modal-list');
      this.$router.push('/employee');
      window.location.reload();
    },
    goToEmployeeIDP() {
      this.$bvModal.hide('alert-assign-modal-list');
      this.$router.push({
          name: `${this.role}-employee`,
          params: { pernumber: this.pernumber },
        });
      window.location.reload();
    },
    disabled(item) {
      const dateExpired = new Date(item.end_at) < new Date();
      return !item.is_valid || (dateExpired && this.role !== 'hr');
    },
    debounceSearchCoach: debounce(function (input) {
      this.searchEmployees(input);
    }, 700),
    async searchEmployees(coachFio) {
      if (coachFio.length > 2) {
        try {
          let res = await api.searchEmployeesByFio(coachFio, false);
          this.searchedEmployees = res.data;
        } catch (e) {
          console.log(e);
        }
      } else {
        this.searchedEmployees = [];
      }
    },
    async getProviders() {
      try {
        let res = await api.getProviders();
        this.providerOptions = res.data.data.map(el => {
          return {
            code: el.id,
            label: el[`name_${this.$i18n.locale}`],
          };
        });
      } catch (e) {
        console.error(e);
      }
    },
    async deleteActivityFromCatalog() {
      try {
        await api.deleteCatalogItem(this.contextMenu.activityId);
        await this.getActivities();
        this.contextMenu.isVisible = false;
      } catch (e) {
        console.error(e);
      }
    },
    async getCopyData() {
      let res = await api.getLearningActivity(this.contextMenu.activityType, this.contextMenu.activityId);
      this.copyData = {};

      this.copyData.activityId = res.data.id;
      this.copyData.ttype = this.contextMenu.activityType;
      this.copyData.name = res.data.name;
      this.copyData.group = res.data.group ? res.data.group.id : '';
      this.copyData.functionModel = res.data.function ? res.data.function.id : '';
      this.copyData.competencies = res.data.competencies ? res.data.competencies : '';
      this.copyData.startdAt = res.data.start_at;
      this.copyData.endAt = res.data.end_at;
      this.copyData.description = res.data.description;
      this.copyData.authorRole = res.data.author_role;
      this.copyData.coachFio = res.data.coach_fio;
      this.copyData.format = res.data.la_format;
      this.copyData.type = res.data.la_type;
      this.copyData.resource = res.data.la_resource;
      this.copyData.method = res.data.la_method;
      this.copyData.provider = res.data.provider;
      this.copyData.duration = res.data.duration;
      this.copyData.targetGroup = res.data.target_group;

      this.copyData.link = res.data.link;

      this.copyData.period = [
        res.data.start_at ? new Date(res.data.start_at) : null,
        res.data.end_at ? new Date(res.data.end_at) : null
      ];
      this.copyData.periodForView = [
        res.data.start_at ? res.data.start_at : null,
        res.data.end_at ? res.data.end_at : null
      ];

      this.copyData.currentRole = window.IDP.role;

      this.copyData.programFiles = res.data.programs;
      this.copyData.educationalMaterialFiles = res.data.educationals;
  },
    async copyEvent() {
      await this.getCopyData();
      await this.$bvModal.show('common-event-create-modal')
    },
    hideActionsMenu() {
      this.actionsMenu.isVisible = false;
    },
    showActionsMenu() {
      this.contextMenuActivity = {};
      this.actionsMenu.isVisible = true;

      this.$nextTick(() => {
        this.actionsMenu.left = Number(event.pageX) - 140;
        this.actionsMenu.top = Number(event.pageY) + 30;
      });
    },
    closeEventModal() {
      this.searchedEmployees = [];
      this.contextMenu.activityId = null;
    }
  },
  async mounted() {
    this.reportsButton.onclick = () => this.isReportsOpened = !this.isReportsOpened;
    this.reportsLoadingButton.onclick = () => this.isReportsOpened = !this.isReportsOpened;

    this.loading = true;

    this.locale = window.IDP.locale;

    if(window.IDP.role) {
      this.role = window.IDP.role;
    }

    if(!window.IDP.role || window.IDP.role === 'employee') {
      this.pernumber = window.IDP.pernumber;
    }

    let url = new URL(window.location.href)
    let params = new URLSearchParams(url.search);

    if(params.get('pernumber')) {
      this.pernumber = params.get('pernumber');
    }

    if(params.get('p')) {
      this.activePage = params.get('p');
    }

    // Init available filter options
    // const activity_formats = window.IDP.activity_formats;
    // const formatsArr = Object.keys(activity_formats);
    // this.formats = Object.keys(activity_formats).map(x => ({id: x, code: `format_${x}`}));

    const activity_source = window.IDP.commonActivityTypes;
    const sourcesArr = Object.keys(activity_source);
    // this.sources = Object.keys(activity_source).map(x => ({id: x, code: x}));

    // Init selected filter values
    let currState = Object.fromEntries(new URLSearchParams(window.location.search));


    let filterCompetencies = [];
    if (currState.filterCompetencies) {
      let filterCompetencies = currState.filterCompetencies.split('_')
        .filter(el => Number(el)).map(el => Number(el));
    }

    if (currState.filterSources) {
      let filterSources = currState.filterSources.split('0');
      filterSources = filterSources.filter(source => sourcesArr.includes(source));
      this.filterSources.splice(0, this.filterSources.length, ...filterSources);
    }

    if (currState.filterName) {
      this.filterName = String(currState.filterName);
    }

    if (currState.sortColumn) {
      this.sortColumn = String(currState.sortColumn);
    }

    if (currState.sortDirection) {
      this.sortDirection = String(currState.sortDirection);
    }

    await this.getActivities();
    await this.getCompetences();
    await this.getProviders()
      .then(() => this.loading = false);
  }
}
</script>

<style scoped>

</style>
